"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = exports.DefaultLinkWrapper = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ = require("../../../");

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

// If you want to use e.g. `next/link`, make your own wrapper like this:
//   import Link from 'next/link';
//   const LinkWrapper = ({ href, ...props }) => (
//     <Link href={href}>
//       <a {...props} />
//     </Link>
//   );
// and pass it as a `LinkWrapper` prop to `CommonChrome`.
// You can also provide an overridden `LinkWrapper` prop for any individual
// link in the `navLinks` prop you pass to `CommonChrome`.
var DefaultLinkWrapper = function DefaultLinkWrapper(props) {
  return /*#__PURE__*/_react["default"].createElement("a", props, props.children);
};

exports.DefaultLinkWrapper = DefaultLinkWrapper;

var NavItem = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(NavItem, _React$Component);

  var _super = _createSuper(NavItem);

  function NavItem() {
    (0, _classCallCheck2["default"])(this, NavItem);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(NavItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          href = _this$props.href,
          icon = _this$props.icon,
          isActive = _this$props.isActive,
          isOpen = _this$props.isOpen,
          hasSub = _this$props.hasSub,
          _this$props$LinkWrapp = _this$props.LinkWrapper,
          LinkWrapper = _this$props$LinkWrapp === void 0 ? DefaultLinkWrapper : _this$props$LinkWrapp,
          newTab = _this$props.newTab,
          rest = (0, _objectWithoutProperties2["default"])(_this$props, ["children", "className", "href", "icon", "isActive", "isOpen", "hasSub", "LinkWrapper", "newTab"]);

      var props = _objectSpread({
        className: (0, _classnames["default"])(className, 'nav-link', {
          'is-active': isActive,
          'is-open': isOpen,
          'has-sub': hasSub
        })
      }, rest);

      if (newTab) {
        props.target = '_blank';
        props.rel = 'noopener noreferrer';
      }

      var content = icon ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "nav-icon-wrapper"
      }, /*#__PURE__*/_react["default"].createElement(_.Icon, {
        name: icon
      })), children) : children;
      var item = href ? /*#__PURE__*/_react["default"].createElement(LinkWrapper, (0, _extends2["default"])({
        href: href
      }, props), content) : /*#__PURE__*/_react["default"].createElement("button", props, content);
      return item;
    }
  }]);
  return NavItem;
}(_react["default"].Component);

(0, _defineProperty3["default"])(NavItem, "propTypes", {
  className: _propTypes["default"].string,
  href: _propTypes["default"].string,
  icon: _propTypes["default"].string,
  isActive: _propTypes["default"].bool,
  isOpen: _propTypes["default"].bool,
  hasSub: _propTypes["default"].bool,
  newTab: _propTypes["default"].bool,
  LinkWrapper: _propTypes["default"].func
});
var _default = NavItem;
exports["default"] = _default;